import React from 'react'
import { CobuText, CobuStack, CobuButton } from '@cobu/ui'
import { useQuery } from '@tanstack/react-query'
import { userService } from '@cobu/api-client'
import { Strings } from '../../constants/Strings';


type BlockedUserItemProps = {
  blockedUserId: string
  onUnblock: (userId: string, userName: string) => void
  isFirstItem?: boolean
  isLastItem?: boolean
}

export default function BlockedUserItem({ blockedUserId, onUnblock, isFirstItem, isLastItem }: BlockedUserItemProps) {
  const { data, error } = useQuery({
    queryKey: ['public-profile', blockedUserId],
    queryFn: () => userService.getUserProfile(blockedUserId as string),
    enabled: !!blockedUserId,
  })
  const user = data?.user
  const strings = Strings.get();
  if (error || !user) return null

  const displayName = user.displayName
  const initials = (user.displayName?.split(' ').map((s: string) => s[0]).join('') || '').slice(0, 2).toUpperCase() || 'UU'

  return (
    <CobuStack mb="$2">
      <CobuStack
        layout="horizontal"
        p="$4"
        ai="center"
        jc="space-between"
        bg="$background"
        w="100%"
        br="$4"
        // No borders between cells; spacing handled by outer margin
      >
        <CobuStack layout="horizontal" ai="center" gap="$3" f={1}>
          <CobuStack w="$10" h="$10" br="$5" bg="$info" jc="center" ai="center">
            <CobuText variant="body" color="$white" fontWeight="bold" fontSize={'$4' as any}>
              {initials}
            </CobuText>
          </CobuStack>

          <CobuText variant="body" color="$cobuDarkBlue" fontWeight="bold" fontSize={'$4' as any}>
            {displayName}
          </CobuText>
        </CobuStack>
        <CobuButton dsVariant="secondary" title={strings.profile.blockedUsers.unblock} onPress={() => onUnblock(blockedUserId, displayName || 'User')} />
      </CobuStack>
    </CobuStack>
  )
}


